<template>
  <div class="keyvisual">
    <div id="key">
      <img class="keyimg" src="/img/top/202010kantouEnd.png">
      <div class="explanation">
        <p class="topmessage">
          全国だれでも、おうちで楽しめるオンライン親子イベント。<br>10月31日(土)まで本サイトのコンテンツをお楽しみいただけます。<br>視聴した感想を書いて、アーカイブ抽選会に参加しよう！<br><br>次回は「運動会」をテーマに11月12日(木)〜14日(土)開催<br>豪華賞品が当たる抽選会も★無料参加チケットを取得しよう！
        </p>
      </div>
      <div class="box">
        <a class="link" href="https://l-ma.info/35r4ffT" target="_blank">
          <span class="button">11月オンラインフェスタのチケットを取る</span>
          <!-- <img class="arrow" src="/img/top/arrow.png"> -->
        </a>
      </div>
      <ul class="flex">
        <li class="txtbox"><p class="title">リトル・ママチャンネル</p><p class="message">オンラインで楽しめるハイハイレースなど、視聴者参加型のコンテンツが盛りだくさん！イベントの最後には豪華抽選会の当選発表も★</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/Lma.png"></li>
      </ul>
      <ul class="flex">
        <li class="txtbox"><p class="title">プレゼントキーワード付き<br>企業LIVE</p><p class="message">LIVEに参加して3つキーワードを集めよう！キーワードを集めた後は抽選会に応募しよう</p><p class="message red">（応募〆切：14：00まで）</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/company.png"></li>
      </ul>
      <ul class="flex">
        <li class="txtbox"><p class="title">学び・遊び・体験LIVE</p><p class="message">ママ主催者による楽しい「学び・体験・遊びLIVE」ひとりで、親子で、気軽に参加しよう♪</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/provider.png"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setUrlForEvent } from '@/helpers/utils.js'
export default {
  mounted () {
    setUrlForEvent('keyVisualUrl')
  }
}
</script>

<style lang="sass" scoped>
.keyvisual
  max-width: 600px
  margin: 0 auto
  padding: 45px 0 10px 0
.explanation
 margin-top: 20px
.topmessage
  text-align: center
  font-size: 13px
  line-height: 22px
.note
  text-align: center
  margin-top: 10px
  font-size: 13px
  line-height: 22px
  color: #FF0000
.box
  padding: 40px 0 30px 0
  text-align: center
.link
  position: relative
  background-color: #ED84A5
  padding: 20px 50px
  border-radius: 8px
  max-width: 335px
  margin: 35px auto 30px auto
  width: 100%
  box-shadow: 2px 2px 4px gray
.button
  color: #fff
  font-weight: bold
.arrow
  position: absolute
  width: 40px
  top: 18px
  left: 320px
ul
  display: flex
  align-items: center
  justify-content: center
  overflow: hidden
  letter-spacing: -.5em
  margin: 25px 10px
li
  display: inline-block
  width: 50%
  letter-spacing: 0
  text-align: center
  margin: 0 0 15px 35px
  .title
    font-size: 16px
    color: #00AB3D
    margin: 10px 0
    font-weight: bold
  .message
    text-align: left
    font-size: 12px
    color: #666
    line-height: 20px
    &.red
      color: #FF0000
  img
    max-width: 80%
@media screen and (max-width: 440px)
  li
    margin: 0 0 15px 10px
</style>
